import React from 'react'

const GroupsContext = React.createContext(null)

const withGroups = Component => props => (
  <GroupsContext.Consumer>
    {groups => <Component {...props} groups={groups} />}
  </GroupsContext.Consumer>
)

export { GroupsContext, withGroups }
